import type { WidgetOptions } from "@/shared/types/widgetOptions";

type TooltipOptions = Exclude<
    WidgetOptions,
    | "width"
    | "lock"
    | "check"
    | "hide"
    | "documentMode"
    | "documentTurnPage"
    | "documentName"
    | "mobileEdit"
    | "group"
    | "aiAssistant"
    | "alignChilds"
    | "textBold"
    | "textStrike"
    | "presentationName"
    | "textItalic"
    | "textUnderline"
>;

export const TOOLTIP_CONTENT: Record<TooltipOptions, string> = {
    align: "Выровнять объекты",
    addText: "Добавить текст",
    arrowEndFirst: "Начало соединительной линии",
    arrowEnd: "Конец соединительной линии",
    border: "Обводка",
    clip: "Обрезать изображение",
    color: "Цвет",
    delete: "Удалить",
    documentDownload: "Скачать",
    documentPreviewPage: "Закрепить страницу",
    filter: "Фильтр",
    lineType: "Тип соединительной линии",
    link: "Ссылка",
    linkTo: "Ссылка",
    media: "Загрузить изображение",
    merge: "Соединить ячейки",
    mindMapDirection: "Направление интеллект-карты",
    shape: "Фигура",
    stickerColor: "Цвет",
    textAlign: "Выровнять текст",
    textBulleted: "Маркированный список",
    textColor: "Цвет",
    textFont: "Шрифт",
    textSize: "Размер шрифта",
    unmerge: "Разъединить ячейки",
    textFormat: "Форматирование",
    contextMenu: "Меню",
    presentationCreate: "Создать презентацию",
    frameAspectRatio: "Формат",
    presentationPlay: "Включить презентацию",
};
